<template>
<body class="hold-transition layout-top-nav">
  <div class="wrapper">
    <!-- Navbar -->
    <nav class="main-header navbar navbar-expand-md navbar-light navbar-white">
      <div class="container">
        <a href="/download" class="navbar-brand">
          <span class="brand-text font-weight-light text-warning">FX</span>hanuman
        </a>

        <div class="collapse navbar-collapse order-3" id="navbarCollapse"></div>
      </div>
    </nav>
    <!-- /.navbar -->

    <!-- Content Wrapper. Contains page content -->
    <div class="content-wrapper">
      <!-- Content Header (Page header) -->
      <div class="content-header">
        <div class="container">
          <div class="row mb-2">
            <div class="col-sm-6">
              <h1 class="m-0 text-dark">
                Product
                <small>EA FXH-CP</small>
              </h1>
            </div>
            <!-- /.col -->
          </div>
          <!-- /.row -->
        </div>
        <!-- /.container-fluid -->
      </div>
      <!-- /.content-header -->

      <!-- Main content -->
      <div class="content">
        <div class="container">
          <div class="row">
            <div class="col-md-6 col-lg-7">
              <div class="card">
                <img
                  class="card-img-top"
                  ng-src="../../../public/img/products/copy-trad-sumo-fx.jpg"
                  alt="Card image cap"
                  src="../../../public/img/products/fxh-cp.jpg"
                />
                <div class="card-body">
                  <p class="card-text ng-binding">EA Copy Trade เป็นอีเอสำหรับ Copy Trade ได้ทุก ๆ โบรกเกอร์</p>
                </div>
              </div>
            </div>
            <div class="col-md-6 col-lg-5 p-1">
              <div class="card">
                <div class="card-body">
                  <h5 class="card-title ng-binding">FXH-CP</h5>
                  <p class="card-text"></p>
                </div>
                <ul class="list-group list-group-flush text-right">
                  <li class="list-group-item">
                    <h3>
                      Price
                      <span class="text-danger ng-binding">500</span> .-
                    </h3>
                  </li>
                  <li class="list-group-item ng-binding">Update : 06/12/2019</li>
                  <li class="list-group-item">
                    <a href="https://drive.google.com/open?id=1GSK9fUaSpEG2FARyJ9ZlnT79a_XCxflv" target="_blank" class="btn btn-danger btn-block">Download Now</a>
                  </li>
                </ul>
              </div>
            </div>

            <!-- Card EA Content  -->
            <div class="col-md-12">
              <div class="card">
                <div class="card-header bg-light">
                  <h4>รายละเอียด</h4>
                </div>

                <div class="container">
                  <div class="md-form col-md-12 mt-1">
                    <h2>
                      <strong>EA Copy Trade</strong>
                    </h2>

                    <p>
                      <strong>เป็น EA Copy Trade ที่มีความสามารถในด้านต่างๆ ดังนี้</strong>
                    </p>

                    <ol>
                      <li>สามารถ Copy การแบ่งปิดออเดอร์ได้ (Partial Close)</li>
                      <li>
                        โหมดการทำงานแบบสองทาง คือ สามารถทำ
                        <span style="color:#d35400">Copy Trade</span>
                        <ol>
                          <li>แบบปกติก็คือ Master 1 way ตัวเดียวมี Slave กี่ตัวก็ได้</li>
                          <li>
                            แบบ Master 2 way&nbsp; ซึ่งเหมาะสำหรับการทำ
                            <a
                              href="https://fxhanuman.com/web/eafx/Beta/Product.php?id=EA0004"
                            >Carry trade</a> ที่หากออเดอร์ฝั่งใดมีการเปลี่ยนแปลง จะทำการ Sync Order ของทั้งสองให้เท่ากัน
                          </li>
                        </ol>
                      </li>
                      <li>
                        สามารถ
                        <span style="color:#d35400">Copy Trade</span> ระหว่าง VPS, Server, Computer ได้ แม้อยู่คนล่ะทวีปกัน เหมาะสำหรับวงเทรดที่มีสลาฟจำนวมากและมาสเตอร์ 1 ตัว
                      </li>
                      <li>
                        สามารถ ReverseOrderType จากออเดอร์ Master เช่น Master เปิด
                        <span
                          style="color:#2980b9"
                        >Buy</span>--&gt; Slave เปิด
                        <span style="color:#e74c3c">Sell</span>
                      </li>
                      <li>
                        สามารถ
                        <span style="color:#d35400">Copy Trade</span>
                        <span style="color:#e67e22"></span>โบรกเกอร์ที่มีชื่อ Symbol แตกต่างกัน เช่น EURUSDpro,EURUSD#
                      </li>
                      <li>ปรับเรทการตามล็อตจากมาสเตอร์ได้ เป็นจำนวนตัวเลขที่ต้องการของ สลาฟ</li>
                    </ol>

                    <p>
                      <strong>เงื่อนไขการใช้งาน EA-CopyTrade </strong>
                    </p>

                    <ol>
                      <li>บัญชี Demo สามารถใช้ฟรี (ต้องการใช้งานกรุณติดต่อ Support)</li>
                      <li>EA จะมี SerialNumber ของแต่ล่ะ มาสเตอร์ ที่ใช้งานจะไม่เหมือนกัน เพื่อป้องกันการใช้งาน ฟังชั่น และเวลา ที่กำหนดไว้</li>
                      <li>ในการใช้งาน EA จะต้องใช้ MT4 ของผู้ซื้อล๊อกอิน 1 MT4 จะเป็น Master ที่ใช้การตั้งค่าของ SerialNumber</li>
                    </ol>

                    <ul>
                      <li>
                        <span
                          style="color:#d35400"
                        >ค่าบริการ 500บาท / 1 Master /&nbsp; 10 Slave ID ( ค่าบริการ จะคิดตามจำนวนสลาฟ )</span>
                      </li>
                      
                    </ul>

                    <p>&nbsp;</p>

                    <p>
                      หากต้องการใช้งาน กรุณาติดต่อ
                      <strong>Line ID: @fxhanuman</strong> เพื่อทำการชำระค่าบริการ
                    </p>

                    <p>และเมื่อชำระเงินเรียบร้อยทาง Fxhanuman จะส่ง SerialNumber ให้ท่านติดตั้งและเปิดใช้งานได้ทันที</p>

                    <p>
                      <a
                        href="http://fxhanuman.com/web/eafx/upload_Images/images/Untitled-2.png"
                        target="_blank"
                      >
                        <img
                          alt
                          src="http://fxhanuman.com/web/eafx/upload_Images/images/Untitled-2.png"
                          style="height:100%; width:100%"
                        />
                      </a>
                    </p>

                    <p>
                      สั่งซื้อ Serial เพื่อใช้งานกับบัญชีจริงได้ที่ Line ID:
                      <span
                        style="color:#27ae60"
                      >@fxhanuman</span>
                    </p>

                    <p>
                      <strong>วิธีการตั้งค่า EA-CopyTrade</strong>
                    </p>

                    <p>
                      <a
                        href="http://fxhanuman.com/web/eafx/upload_Images/images/Untitled-1.png"
                        target="_blank"
                      >
                        <img
                          alt
                          src="http://fxhanuman.com/web/eafx/upload_Images/images/Untitled-1.png"
                          style="height:100%; width:100%"
                        />
                      </a>
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <!-- End Card EA Content  -->
            <!-- /.row -->
          </div>
        </div>
        <!-- /.container-fluid -->
      </div>
      <!-- /.content -->
    </div>
    <!-- /.content-wrapper -->

    <!-- Main Footer -->
    <footer class="main-footer">
      <!-- To the right -->
      <div class="float-right d-none d-sm-inline">Anything you want</div>
      <!-- Default to the left -->
      <strong>
        Copyright &copy;2019
        <a href="/download" class="text-dark">
          <b class="text-warning">FX</b>hanuman
        </a>.
      </strong> All rights reserved.
    </footer>
  </div>
  <!-- ./wrapper -->
</body>
</template>

<script>
export default {
  name: "copytrade"
};
</script>